<template>
  <div>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="visible" width="70%">
      <el-form ref="form" :model="dataForm" label-width="80px" @submit.native.prevent class="operationControl">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="学员名称" prop="userName">
              <el-input v-model="dataForm.userName" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="电话" prop="userPhone">
              <el-input v-model="dataForm.userPhone" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-row>
      </el-form>
      <el-table :data="dataList" v-loading="loading" element-loading-text="拼命加载中" class="mb20"
                style="width: 100%;" height="640">
        <el-table-column
          type="index"
          label="序号"
          width="80"
        ></el-table-column>
        <el-table-column prop="userName" label="姓名"></el-table-column>
        <el-table-column prop="userPhone" label="电话"></el-table-column>
        <el-table-column prop="totalHours" label="课程总时长"></el-table-column>
        <el-table-column prop="totalHoursLearned" label="已学习时长（分）" width="200">
          <template slot-scope="scope">
              <span v-if="scope.row.totalHoursLearned" v-html="scope.row.totalHoursLearned">
              </span>
            <span v-else>
                0
              </span>
          </template>
        </el-table-column>
        <el-table-column label="学习状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.totalHoursLearned >= scope.row.totalHours"  type="success">已完成
            </el-tag>
            <el-tag v-else type="danger">学习中
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="考试状态">
          <template slot-scope="scope">
            <template v-if="scope.row.associatedExam">
              <el-tag type="success" v-if="scope.row.examStatus == 0">已完成</el-tag>
              <el-tag type="warning" v-if="scope.row.examStatus == 1">未开始</el-tag>
            </template>
            <template v-else>
              ---
            </template>
          </template>
        </el-table-column>
        <el-table-column label="考试结果">
          <template slot-scope="scope">
            <template v-if="scope.row.associatedExam">
              <el-tag v-if="scope.row.eligibleStatus == 0" type="success">合格
              </el-tag>
              <el-tag v-if="scope.row.eligibleStatus == 1" type="danger">不合格
              </el-tag>
              <el-tag v-if="scope.row.eligibleStatus == 2" type="primary">批卷中
              </el-tag>
              <span v-if="scope.row.eligibleStatus == undefined">
                ---
              </span>
            </template>
            <template v-else>
              ---
            </template>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="350">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="showStudyProgress(scope.row.id)"
            >详情
            </el-button>
            <el-button
              type="text"
              size="mini"
              v-if="enableVerification"
              @click="showVFaceImageDetails(scope.row)"
            > 认证记录
            </el-button>

            <el-button
              type="text"
              size="mini"
              v-if="!scope.row.totalHoursLearned  || scope.row.totalHoursLearned < scope.row.totalHours"
              @click="pushTrainingReminderMessage(scope.row.id)"
            >培训提醒消息
            </el-button>
            <el-button
              v-if="scope.row.totalHoursLearned >= scope.row.totalHours"
              size="mini"
              type="text"
              @click="trainingRecordExport(scope.row)">导出培训记录
            </el-button>
            <el-button
              v-if="scope.row.totalHoursLearned >= scope.row.totalHours"
              size="mini"
              type="text"
              @click="proofOfClassHoursExport(scope.row)">生成学时证明
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:20px; float:right;"
        @size-change="sizeChange"
        :current-page="page"
        @current-change="pageChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <studyProgress ref="studyProgress"></studyProgress>
      <vFaceImageDetails ref="vFaceImageDetails"></vFaceImageDetails>
      <span slot="footer">
        <div class="f-b-c">
          <div></div>
          <div>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import employeeFile from "@/api/new/employee_file.js";
import studyProgress from "@/components/studyProgress";
import vFaceImageDetails from "@/pages/trainingManagement/verification/vFaceImageDetails.vue";
import student from "@/api/new/student.js";
import util from "@/common/util.js";


export default {
  name: "taskDetails",
  components: {studyProgress, vFaceImageDetails},
  data() {
    return {
       visible: false,
       programTasksId: undefined,
       taskName: undefined,
       dataForm: {
         userName: undefined,
         userPhone: undefined
       },
       page: 1,
       pageSize: 15,
       total: 0,
       loading: false,
       dataList: [],
      enableVerification: false
    }
  },
  methods: {
    show(programTasksId, taskName, enableVerification){
      this.enableVerification = enableVerification;
      this.programTasksId = programTasksId;
      this.taskName = taskName;
      this.visible =  true;
      this.resetForm('form');
      this.search();
    },
    search(){
       this.page = 1;
       this.pageSize = 15;
       this.queryList();
    },
    queryList() {
      this.loading = true;
      student.getTrainList({
        ...this.dataForm,
        page: this.page,
        pageSize: this.pageSize,
        programTasksId: this.programTasksId
      }).then(res => {
        this.dataList = res.data.records;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    //重置表单
    resetForm(formName) {
      // this.$refs[formName].resetFields();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.queryList();
    },
    pageChange(e) {
      this.page = e;
      this.queryList();
    },
    showVFaceImageDetails(row){
      this.$refs.vFaceImageDetails.show(row.userId,  row.id);
    },
    showStudyProgress(id) {
      this.$refs.studyProgress.open(id);
    },
    pushTrainingReminderMessage(id) {
      student.pushTraininReminderMessage({detailId: id}).then(res => {
        this.$message({
          message: '推送成功',
          type: 'success'
        });
      });
    },
    /**
     *  导出培训记录
     * */
    trainingRecordExport(row) {
      let parmas = {
        userId: row.userId,
        programTasksId: row.programTasksId
      }
      employeeFile.trainingRecordExport(parmas).then(res => {
        let fileName = '';
        if (this.taskName) {
          fileName += this.taskName + '-';
        }
        if (row.userName) {
          fileName += row.userName + '-';
        }
        fileName += '培训记录';
        util.download(res.data, fileName);
      }).catch( (error) => {
        console.log('error msg %o', error)
        this.$message.error({
          showClose: true,
          message: error.response.data.message,
          duration: 2000
        });
      });
    },
    /**
     * 生成学时证明
     */
    proofOfClassHoursExport(row) {
      let parmas = {
        userId: row.userId,
        trainingDetailListId: row.id
      }
      employeeFile.proofOfClassHoursExport(parmas).then(res => {
        let fileName = '';
        if (this.taskName) {
          fileName += this.taskName.trim() + '-';
        }
        if (row.userName) {
          fileName += row.userName.trim() + '-';
        }
        fileName += '学时证明';
        util.download(res.data, fileName);
      }) .catch( (error) => {
        console.log('error msg %o', error.response)
        this.$message.error({
          showClose: true,
          message: error.response.data.message,
          duration: 2000
        });
      });
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/task/taskDetails.vue